<h1 mat-dialog-title>
  @if (item) {
    <span>Edit</span>
  } @else {
    <span>New</span>
  }
  time entry for {{ getDisplayDate() | date : "EEEE, d MMM" }}
  <mat-datepicker-toggle [for]="datePicker" style="display: inline-block;">
  </mat-datepicker-toggle>
  <mat-datepicker #datePicker (closed)="onDateChanged()"></mat-datepicker>
  <input matInput [matDatepicker]="datePicker" style="position: absolute; width: 0; height: 0; opacity: 0; pointer-events: none;" [(ngModel)]="headerDate">
</h1>
<div class="timesheet">

    <app-timesheet-edit
    #timesheetEdit
    (actioned)="onNoClick()"
    (scrollRequested)="scroll($event)"
    (calendarEventSelected)="onCalendarEventSelected($event)"
    [calendarIdsForDay]="calendarIdsForDay"
    [item]="item"
    [selectedDate]="selectedDate"
    [popup]="true"

    ></app-timesheet-edit>
</div>
